<template>
	<section>
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters">
				<el-form-item>
					<el-input v-model="filters.roleName" placeholder="角色名称"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" v-on:click="getRoles">查询</el-button>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="handleAdd">新增</el-button>
				</el-form-item>
			</el-form>
		</el-col>

		<!--列表-->
		<el-table :data="roles" border stripe highlight-current-row v-loading="listLoading" @selection-change="selsChange" @sort-change="sortChange" style="width: 100%;"
		:header-row-style="{backgroundColor:'#eef1f6',lineHeight:'20px',color:'#000'}" :row-style="{height:'30px'}">
			<el-table-column type="selection" width="55">
			</el-table-column>
			<el-table-column type="index" label="编号"  width="80">
			</el-table-column>
			<el-table-column prop="role_name" label="角色名称" width="120" sortable>
			</el-table-column>
			<el-table-column prop="role_desc" label="描述" width="150"  sortable>
			</el-table-column>
			<el-table-column label="操作" >
				<template slot-scope="scope">
					<el-button size="small" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
					<el-button type="danger" size="small" @click="handleDel(scope.$index, scope.row)">删除</el-button>
				</template>
			</el-table-column>
		</el-table>

		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-col :span="8"> <el-button type="danger" @click="batchRemove" :disabled="this.sels.length===0">批量删除</el-button></el-col>
			<el-col :span="8">
				<el-pagination @size-change="handleSizeChange"  @current-change="handleCurrentChange" :current-page="currentPage"
							:page-sizes="[20, 50, 80, 100]" :page-size="pageSize"  layout="total, sizes, prev, pager, next, jumper" :total="total" style="float:left;">
				</el-pagination>
			</el-col>
		</el-col>

		<!--编辑界面-->
		<el-dialog title="编辑" :visible.sync="editFormVisible" :close-on-click-modal="false"  size="tiny">
			<el-form :model="editForm"   label-width="100px" :rules="editFormRules" ref="editForm">
				<el-form-item label="角色名称" prop="role_name">
					<el-input v-model="editForm.role_name" auto-complete="off" ></el-input>
				</el-form-item>
				<el-form-item label="描述" prop="role_desc">
				     <el-input v-model="editForm.role_desc" auto-complete="off" ></el-input>
				</el-form-item>
				
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="editFormVisible = false">取消</el-button>
				<el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
			</div>
		</el-dialog>

	
	</section>
</template>

<script>
	//import util from '../../common/js/util'

	import { getRoleListPage,addRole,editRole, removeRole,batchRemoveRole } from '../../api/api';
 
 let CurrentUserID="",Session=""; 
	export default {
		data() {
			return {
				filters: {
					roleName: ''
				},
				roles: [],
				total: 0,
				pageSize:20,
				currentPage: 1,
				listLoading: false,
				sels: [],//列表选中列
                 prop:"", 
				 order:"",
				editFormVisible: false,//编辑界面是否显示
				editLoading: false,
				editFormRules: {
					role_name: [
						{ required: true, message: '请输入角色名称', trigger: 'blur' }
					]
				},
				//编辑界面数据
				editForm: {
					role_id: 0,
					role_name: '',					
					role_desc:''
				},


				formStatus: 0   //界面状态 0新增 1修改 2查看

			}
		},
		methods: {
		
			 handleSizeChange(val) {
				this.pageSize=val;                 
				this.getRoles();
             },		
			handleCurrentChange(val) {
				this.currentPage = val;
				this.getRoles();
			},
			//获取角色列表
			getRoles() {
				let para = {
				    CurrentUserID:CurrentUserID,
					currentPage: this.currentPage,
					pageSize:this.pageSize,
					roleName: this.filters.roleName,
					systype:3,
					sortName:this.prop,
					sortOrder:this.order,
					Session:Session
				};
				this.listLoading = true;
				

            this.$http.jsonp(getRoleListPage, {params: para}).then(
                   function(res){                         
                         if (res.data.result_code==200)
                         {
							 this.total = res.data.rolelist.total;
					         this.roles = res.data.rolelist.roles;
					         this.listLoading = false;
                           
                         }
                         else{                           
                              
                             this.listLoading = false;
							 
							 if (res.data.result_code==911)
							  {
                                 this.$router.push({ path: "/login"});
								  return;
							  }

                              if (res.data.result_code==600)
							  {
									this.$message({
										message:'接口错误',
										type: 'error'
									});
                                  return;
							  }
							
                         }
                       

                   },
                   function(res)
                   {
                        this.$message({
                                message:'接口访问失败',
                                type: 'error'
                              });
                      this.listLoading = false;
                   }
           )

			},
			//删除
			handleDel: function (index, row) {
				this.$confirm('确认删除该记录吗?', '提示', {
					type: 'warning'
				}).then(() => {
					this.listLoading = true;
					//NProgress.start();
					let para = { CurrentUserID:CurrentUserID,role_id: row.role_id,sys_type:3,Session:Session };


                   this.$http.jsonp(removeRole, {params: para}).then(
                   function(res){                         
                         if (res.data.result_code==200)
                         {
							this.listLoading = false;
							this.$message({
							message: '删除成功',
							type: 'success'
						    });
							this.getRoles();
                           
                         }
                         else{                           
                             
							this.listLoading = false;
							if (res.data.result_code==911)
							  {
                                  this.$router.push({ path: "/login"});
								  return;
							  }

                              if (res.data.result_code==600)
							  {
									this.$message({
										message:'接口错误',
										type: 'error'
									});
                                  return;
							  }
							if  (res.data.result_code==914)
                            {
                              this.$message({
                                message:'没有删除权限',
                                type: 'error'
                              });
							   return;
							}
                             
                         }
                       

                   },
                   function(res)
                   {
                        this.$message({
                                message:'接口访问失败',
                                type: 'error'
                              });
                      this.listLoading = false;
                   });


				}
				
				).catch(() => {

				});
			},
			//显示编辑界面
			handleEdit: function (index, row) {
				
				this.formStatus=1;
				this.editFormVisible = true;
				
				this.editForm = Object.assign({}, row);
                if (this.$refs['editForm'] !== undefined) {						
                    this.$refs['editForm'].resetFields();
                }
				
				
			},
			//显示新增界面
			handleAdd: function () {
				
				this.formStatus=0;
				this.editFormVisible = true;
				if (this.$refs['editForm'] !== undefined) {						
                    this.$refs['editForm'].resetFields();
                }
				this.editForm = {
					role_id: 0,
					role_name: '',
					role_desc: ''
				};

				
			},
			//编辑
			editSubmit: function () {
				this.$refs.editForm.validate((valid) => {
					if (valid) {
						this.$confirm('确认提交吗？', '提示', {}).then(() => {
							this.editLoading = true;
							//NProgress.start();
							let para = Object.assign({}, this.editForm);
							para["sys_type"] = "3";
							para["CurrentUserID"] = CurrentUserID;
							para["Session"]=Session;

			   let roleUrl=	addRole;			  
               if (this.formStatus==1)
			   {
                  roleUrl=editRole;
			   }
                this.$http.jsonp(roleUrl, {params: para}).then(
                   function(res){                         
                         if (res.data.result_code==200)
                         {
							    if (this.$refs['editForm'] !== undefined) {						
									this.$refs['editForm'].resetFields();
								}
							 	this.editLoading = false;								
								this.$message({
									message: '提交成功',
									type: 'success'
								});
								

								if (this.formStatus==1)
								{
								  this.editFormVisible = false;
								}
								this.getRoles();
                           
                         }
                         else{                           
                               this.editLoading = false;
							 if (res.data.result_code==911)
							  {
                                 this.$router.push({ path: "/login"});
								  return;
							  }

                              if (res.data.result_code==600)
							  {
									this.$message({
										message:'接口错误',
										type: 'error'
									});
                                  return;
							  }
							if  (res.data.result_code==912)
                            {
                              this.$message({
                                message:'没有新增权限',
                                type: 'error'
                              });
							   return;
							}
							if  (res.data.result_code==913)
                            {
                              this.$message({
                                message:'没有编辑权限',
                                type: 'error'
                              });
							   return;
							}
                         }
                       

                   },
                   function(res)
                   {
                        this.$message({
                                message:'接口访问失败',
                                type: 'error'
                              });
							  this.editLoading = false;	
                      
                   }
           )


						});
					}
				});
			},

			selsChange: function (sels) {
				this.sels = sels;
			},
			sortChange:function(order){
                   this.prop=order.prop;
				   this.order=order.order,
                 this.getRoles();
			},
			//批量删除
			batchRemove: function () {
				var ids = this.sels.map(item => item.role_id).toString();
				this.$confirm('确认删除选中记录吗？', '提示', {
					type: 'warning'
				}).then(() => {
					this.listLoading = true;
					//NProgress.start();
					let para = { ids: ids,CurrentUserID:CurrentUserID,sys_type:3,Session:Session };


                   this.$http.jsonp(batchRemoveRole, {params: para}).then(
                   function(res){                         
                         if (res.data.result_code==200)
                         {
							this.listLoading = false;
							this.$message({
							message: '删除成功',
							type: 'success'
						    });
							this.getRoles();
                           
                         }
                         else{                           
                              
                             this.listLoading = false;
							 if (res.data.result_code==911)
							  {
                                  this.$router.push({ path: "/login"});
								  return;
							  }

                              if (res.data.result_code==600)
							  {
									this.$message({
										message:'接口错误',
										type: 'error'
									});
                                  return;
							  }
							if  (res.data.result_code==914)
                            {
                              this.$message({
                                message:'没有删除权限',
                                type: 'error'
                              });
							   return;
							}
                         }
                       

                   },
                   function(res)
                   {
                        this.$message({
                                message:'接口访问失败',
                                type: 'error'
                              });
                      this.listLoading = false;
                   });


				}).catch(() => {

				});
			}
		},
		mounted() {
			CurrentUserID=sessionStorage.getItem('userID')==null?0:sessionStorage.getItem('userID'); 
            Session=sessionStorage.getItem('session')==null?0:sessionStorage.getItem('session'); 
			this.getRoles();
		}
	}

</script>

<style scoped>
  .el_input_width{
	 width:220px; 
  }
</style>


// WEBPACK FOOTER //
// role.vue?222805a5